import {createSelector} from 'reselect'
import {getLoggedInUser} from '../../loggedInUser/selectors'

export default function(getCommentsState) {
    const getComments = state => getCommentsState(state).comments
    const getCommentsUsers = state => getCommentsState(state).users
    const getCommentsCount = state => getCommentsState(state).commentsCount
    const getAllCommentsUserIds = state => getCommentsState(state).allCommentsUserIds
    const areCommentsLoaded = state => getCommentsState(state).commentsLoaded
    const isNewCommentsOnTop = state => getCommentsState(state).isNewCommentsOnTop
    const isLoading = state => getCommentsState(state).loading
    const isSendingComment = state => getCommentsState(state).sendingComment
    const getRecentlyAddedCommentsIds = state => getCommentsState(state).recentlyAddedCommentsIds
    const getCommentsScrollTo = state => getCommentsState(state).commentsScrollTo
    const getEditingCommentId = state => getCommentsState(state).editingCommentId
    const getEditingCommentText = state => getCommentsState(state).editingCommentText
    const getUpdatingCommentId = state => getCommentsState(state).updatingCommentId
    const isShowNewCommentInput = state => getCommentsState(state).showNewCommentInput
    const getNewCommentsTexts = state => getCommentsState(state).newCommentsTexts

    const needMoreComments = createSelector(
        isLoading,
        areCommentsLoaded,
        (loading, loaded) => !loading && !loaded
    )

    const getCommentsInfo = createSelector(
        getComments,
        getCommentsUsers,
        getCommentsCount,
        getAllCommentsUserIds,
        (comments, users, commentsCount, allCommentsUserIds) => ({comments, users, commentsCount, allCommentsUserIds})
    )

    const getNewestCommentId = createSelector(
        getComments,
        (comments) => comments.length > 0 ? comments[0].id : null
    )

    const getUsers = createSelector(
        getCommentsUsers,
        getLoggedInUser,
        (commentsUsers, loggedInUser) => {
            return {...commentsUsers, [loggedInUser.id]: loggedInUser}
        }
    )

    return {
        getComments,
        getUsers,
        getCommentsCount,
        getAllCommentsUserIds,
        getCommentsInfo,
        needMoreComments,
        isNewCommentsOnTop,
        getRecentlyAddedCommentsIds,
        getCommentsScrollTo,
        getNewestCommentId,
        getEditingCommentId,
        getEditingCommentText,
        isLoading,
        isSendingComment,
        getUpdatingCommentId,
        isShowNewCommentInput,
        getNewCommentsTexts,
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/comments/selectorsGenerator.js